import { render, staticRenderFns } from "./paramsQuery.vue?vue&type=template&id=3bb6e39e&scoped=true&"
import script from "./paramsQuery.vue?vue&type=script&lang=js&"
export * from "./paramsQuery.vue?vue&type=script&lang=js&"
import style0 from "./paramsQuery.vue?vue&type=style&index=0&id=3bb6e39e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6e39e",
  null
  
)

export default component.exports